import { render, staticRenderFns } from "./messageDetails.vue?vue&type=template&id=61688ddd&scoped=true"
import script from "./messageDetails.vue?vue&type=script&lang=js"
export * from "./messageDetails.vue?vue&type=script&lang=js"
import style0 from "./messageDetails.vue?vue&type=style&index=0&id=61688ddd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61688ddd",
  null
  
)

export default component.exports